import { EquipmentPartModel, InspectionModel } from '../data/types';

export function retainObservedFitments(
  inspection: InspectionModel,
  parts: EquipmentPartModel[],
): InspectionModel {
  const referenced = new Set(
    inspection.inspectionCategoryTypes.flatMap((category) =>
      category.observations.map((observation) => observation.entityExternalId),
    ),
  );
  const retained = new Map(
    (inspection.fitmentSnapshots ?? []).map((part) => [part.externalId, part]),
  );
  for (const part of parts) {
    if (referenced.has(part.externalId) && !retained.has(part.externalId)) {
      retained.set(part.externalId, part);
    }
  }
  return retained.size !== (inspection.fitmentSnapshots?.length ?? 0)
    ? { ...inspection, fitmentSnapshots: [...retained.values()] }
    : inspection;
}
